import { render } from "./CodeInputVerify.vue?vue&type=template&id=6d1ccb58&scoped=true"
import script from "./CodeInputVerify.vue?vue&type=script&lang=js"
export * from "./CodeInputVerify.vue?vue&type=script&lang=js"

import "./CodeInputVerify.vue?vue&type=style&index=0&id=6d1ccb58&scoped=true&lang=css"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1ccb58"]])

export default __exports__